import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "md:flex-row bg-white rounded-xl md:p-0 shadow md:w-auto m-4" }
const _hoisted_2 = { class: "p-2" }
const _hoisted_3 = {
  id: "citiesTable",
  class: "stripe hover table-auto"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "ID"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Nombre"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Modificar"),
  /*#__PURE__*/_createElementVNode("th", { class: "ion-text-center" }, "Activar / Desactivar")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOperators, (value, key) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "ion-text-center",
              key: key
            }, [
              _createElementVNode("td", null, _toDisplayString(key), 1),
              _createElementVNode("td", null, _toDisplayString(value.nombre), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_ion_button, {
                  onClick: ($event: any) => (_ctx.edit(key, value.nombre)),
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_ion_toggle, {
                  onIonChange: ($event: any) => (_ctx.changeStatus(key.toString(), $event)),
                  checked: value.status
                }, null, 8, ["onIonChange", "checked"])
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}